import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../components/auth/AuthContext';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CircularProgress,
  Box,
} from '@mui/material';
import axios from 'axios';

const AllParents = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { schoolId: contextSchoolId } = useAuth();
  const schoolId = location.state?.schoolId || contextSchoolId;

  const [parents, setParents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchParents = async () => {
      try {
        const response = await axios.get('https://kidsm.vercel.app/api/schools/parents', {
          params: { schoolId },
        });
        setParents(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching parents:', error);
        setLoading(false);
      }
    };

    if (schoolId) fetchParents();
  }, [schoolId]);

  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
    hover: { scale: 1.02, transition: { duration: 0.2 } },
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress color="primary" />
      </Box>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4, bgcolor: '#f8f9fa', minHeight: '100vh' }}>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#2c3e50', mb: 3 }}>
          All Parents
        </Typography>
        <Grid container spacing={2}>
          {parents.map((parent) => (
            <Grid item xs={12} sm='6' md='4' key={parent._id}>
              <motion.div variants={cardVariants} initial="hidden" animate="visible" whileHover="hover">
                <Card
                  sx={{ p: 2, boxShadow: 3, bgcolor: '#fff', cursor: 'pointer' }}
                  onClick={() => navigate('/parent-details', { state: { parent } })}
                >
                  <CardContent>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333', mb: 1 }}>
                      {parent.parentName}
                    </Typography>
                    <Typography sx={{ color: '#666' }}>ID Number: {parent.idNumber}</Typography>
                    <Typography sx={{ color: '#666' }}>Learner: {parent.learnerName}</Typography>
                    <Typography sx={{ color: '#666' }}>Admission: {parent.learnerAdmissionNumber}</Typography>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </motion.div>
    </Container>
  );
};

export default AllParents;